// Greaseproof Paper Product Functionality
console.log('Product Greaseproof Paper JS loaded');
console.log('Body classes:', document.body.className);

class GreaseproofPaperProduct {
  constructor() {
    console.log('GreaseproofPaperProduct initialized');

    // State
    this.selectedCutType = 'FullCut';
    this.selectedColours = '1Colour';
    this.selectedCoverage = 'LessThan50';
    this.selectedQuantity = 5000;


    // Live pricing cache
    this.productData = null;
    this.currentUnitPrice = 0;
    this.variantPriceCache = new Map();

    // Constants
    this.UNITS_PER_CARTON = 1000;
    this.RUSH_MULTIPLIER = 1.3; // 30% surcharge

    // Pricing quantities
    this.pricingQuantities = [5000, 10000];

    // Plate fee variant ID provided by user
    this.PLATE_FEE_VARIANT_ID = '51810726478106';

    // Variant mapping structure: CutType_Colours_Coverage -> Quantity -> Variant ID
    // 
    // IMPORTANT: The variant IDs here MUST match the variant IDs in your Shopify product.
    // When a user selects a quantity in the pricing table, this mapping determines which
    // variant ID is used when adding to cart. The structure is:
    // 
    // "CutType_Colours_Coverage": {
    //   "5000": "variant_id_for_5000_quantity",
    //   "10000": "variant_id_for_10000_quantity"
    // }
    //
    // The variant IDs must correspond to actual product variants in Shopify that have:
    // - The matching Cut Type option value
    // - The matching Colours option value  
    // - The matching Coverage option value
    // - The matching Quantity (5000 or 10000)
    //
    // TODO: Replace placeholder variant IDs with actual greaseproof paper variant IDs from Shopify
    this.variantMapping = {
      "CustomCut_1Colour_LessThan50": { "5000": "51458834825498", "10000": "51458834858266", "15000": "51458834891034" },
      "CustomCut_2Colours_LessThan50": { "5000": "51458835218714", "10000": "51458835251482", "15000": "51458835284250" },
      "CustomCut_1Colour_MoreThan50": { "5000": "51458835022106", "10000": "51458835054874", "15000": "51458835087642" },
      "CustomCut_2Colours_MoreThan50": { "5000": "51458835415322", "10000": "51458835448090", "15000": "51458835480858" },
      "FullCut_1Colour_LessThan50": { "5000": "51458832466202", "10000": "51458832498970", "15000": "51458832531738" },
      "FullCut_2Colours_LessThan50": { "5000": "51458832859418", "10000": "51458832892186", "15000": "51458832924954" },
      "FullCut_1Colour_MoreThan50": { "5000": "51458832662810", "10000": "51458832695578", "15000": "51458832728346" },
      "FullCut_2Colours_MoreThan50": { "5000": "51458833056026", "10000": "51458833088794", "15000": "51458833121562" },
      "HalfCut_1Colour_LessThan50": { "10000": "51458833285402", "20000": "51458833350938", "30000": "51458833383706" },
      "HalfCut_2Colours_LessThan50": { "10000": "51458833678618", "20000": "51458833744154", "30000": "51458833776922" },
      "HalfCut_1Colour_MoreThan50": { "10000": "51458833482010", "20000": "51458833547546", "30000": "51458833580314" },
      "HalfCut_2Colours_MoreThan50": { "10000": "51458833875226", "20000": "51458833940762", "30000": "51458833973530" },
      "ThirdCut_1Colour_LessThan50": { "15000": "51458834104602", "30000": "51458834170138", "45000": "51458834202906" },
      "ThirdCut_2Colours_LessThan50": { "15000": "51458834497818", "30000": "51458834563354", "45000": "51458834596122" },
      "ThirdCut_1Colour_MoreThan50": { "15000": "51458834301210", "30000": "51458834366746", "45000": "51458834399514" },
      "ThirdCut_2Colours_MoreThan50": { "15000": "51458834694426", "30000": "51458834759962", "45000": "51458834792730" }
    };

    this.productHandles = {
      CustomCut: "greaseproof-paper-custom-cut",
      FullCut: "greaseproof-paper-full-cut",
      HalfCut: "greaseproof-paper-half-cut",
      ThirdCut: "greaseproof-paper-third-cut"
    };

    this.productDataMap = {};


    this.init().catch(error => console.error('Initialization error:', error));
  }

  async init() {
    this.setupCutTypeSelector();
    this.setupColoursSelector();
    this.setupCoverageSelector();

    this.setupTooltips();
    this.setupFormSubmission();
    this.setupFileUpload();
    this.setupPersonaliseUpload();
    this.setupShippingCalculator();
    this.setupDynamicDescription();
    this.autoSelectMOQQuantity(); // Auto-select MOQ quantity for initial cut/colours/coverage combination
    await this.updatePricingTable();
    this.checkCartAddSuccess();
    this.preventAutoScroll();
  }


  // Auto-select MOQ quantity based on cut type, colours, and coverage
  autoSelectMOQQuantity() {
    const pricingKey = this.getPricingKey();
    const variants = this.variantMapping[pricingKey];

    if (!variants) return;

    // Get the minimum quantity available for this configuration (which is the MOQ)
    const quantities = Object.keys(variants).map(q => parseInt(q)).sort((a, b) => a - b);
    const moqQuantity = quantities[0]; // First (smallest) quantity is the MOQ

    console.log(`Auto-selecting MOQ for ${pricingKey}: ${moqQuantity}`);

    // Update the selected quantity
    this.selectedQuantity = moqQuantity;
  }

  // Initialize FullCut selection on page load
  initializeCutTypeSelection() {
    const cutButtons = document.querySelectorAll('.size-btn');

    // Force FullCut selection immediately
    this.forceFullCutSelection();

    // Also force it again after delays to override any other scripts
    setTimeout(() => {
      this.forceFullCutSelection();
    }, 100);

    setTimeout(() => {
      this.forceFullCutSelection();
    }, 500);
  }

  // Force FullCut selection
  forceFullCutSelection() {
    const cutButtons = document.querySelectorAll('.size-btn');

    cutButtons.forEach(btn => {
      btn.classList.remove('selected');

      // Select FullCut button
      if (btn.dataset.size === 'FullCut') {
        btn.classList.add('selected');
        this.selectedCutType = 'FullCut';
        console.log('Forced FullCut selection');
      }
    });
  }

  setupCutTypeSelector() {
    const cutButtons = document.querySelectorAll('.size-btn');
    console.log('Setting up cut type selector, found buttons:', cutButtons.length);

    // Initialize FullCut as selected on page load
    this.initializeCutTypeSelection();

    cutButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        console.log('Cut type button clicked:', btn.dataset.size);

        // Update selection
        cutButtons.forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');

        this.selectedCutType = btn.dataset.size;
        console.log('Cut type selected:', this.selectedCutType);

        // Toggle custom size inputs visibility
        const customSizeInputs = document.getElementById('custom-size-inputs');
        if (customSizeInputs) {
          if (this.selectedCutType === 'CustomCut') {
            customSizeInputs.style.display = 'block';
          } else {
            customSizeInputs.style.display = 'none';
          }
        }

        this.autoSelectMOQQuantity(); // Auto-select MOQ quantity when cut type changes
        this.updatePricingTable();
        this.updateDynamicDescription();
        this.updateMediaGalleryForSelectedVariant();
      });
    });
  }

  setupColoursSelector() {
    const colourButtons = document.querySelectorAll('.print-type-btn');
    console.log('Setting up colours selector, found buttons:', colourButtons.length);

    colourButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        // Update selection
        colourButtons.forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');

        this.selectedColours = btn.dataset.printType;
        console.log('Colours selected:', this.selectedColours);

        // Auto-select MOQ quantity based on new colours
        this.autoSelectMOQQuantity();

        this.updatePricingTable();
        this.updateMediaGalleryForSelectedVariant();
      });
    });
  }


  setupCoverageSelector() {
    const coveragePills = document.querySelectorAll('.lids-pill');
    coveragePills.forEach(pill => {
      pill.addEventListener('click', () => {
        // Update selection
        coveragePills.forEach(p => p.classList.remove('selected'));
        pill.classList.add('selected');

        const coverageValue = pill.dataset.lids;
        this.selectedCoverage = coverageValue;

        console.log('Coverage selected:', coverageValue);

        this.updatePricingTable();
      });
    });
  }

  setupTurnaroundSelector() {
    // Removed turnaround selector logic
  }

  setupTooltips() {
    const tooltipIcons = document.querySelectorAll('.tooltip-icon[data-tooltip]');

    tooltipIcons.forEach(icon => {
      let tooltip = null;

      const showTooltip = (e) => {
        // Remove any existing tooltips
        document.querySelectorAll('.tooltip-popup').forEach(t => t.remove());

        const tooltipText = icon.getAttribute('data-tooltip');
        if (!tooltipText) return;

        // Create tooltip element
        tooltip = document.createElement('div');
        tooltip.className = 'tooltip-popup';
        tooltip.innerHTML = tooltipText;

        // Style the tooltip
        Object.assign(tooltip.style, {
          position: 'absolute',
          background: '#000000',
          color: '#ffffff',
          padding: '12px 16px',
          borderRadius: '6px',
          fontSize: '14px',
          fontWeight: '400',
          lineHeight: '1.4',
          maxWidth: '300px',
          width: 'auto',
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
          zIndex: '9999',
          opacity: '0',
          visibility: 'hidden',
          transition: 'all 0.2s ease',
          pointerEvents: 'none'
        });

        // Add to DOM - append to the icon's parent container for better positioning
        const container = icon.closest('.form__label') || icon.parentElement;
        container.style.position = 'relative';
        container.appendChild(tooltip);

        // Position tooltip relative to icon
        const iconRect = icon.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();

        // Get tooltip dimensions after adding to DOM
        tooltip.style.visibility = 'visible';
        tooltip.style.opacity = '0';
        const tooltipRect = tooltip.getBoundingClientRect();
        tooltip.style.visibility = 'hidden';

        // Calculate position relative to container
        const iconLeft = iconRect.left - containerRect.left;
        const iconTop = iconRect.top - containerRect.top;

        // Position above the icon, centered horizontally
        let left = iconLeft + (iconRect.width / 2) - (tooltipRect.width / 2);
        let top = iconTop - tooltipRect.height - 8;

        // Keep tooltip within viewport
        const viewportWidth = window.innerWidth;
        const tooltipLeftInViewport = containerRect.left + left;
        const tooltipRightInViewport = tooltipLeftInViewport + tooltipRect.width;

        // Adjust horizontal position if going off screen
        if (tooltipLeftInViewport < 10) {
          left = 10 - containerRect.left;
        } else if (tooltipRightInViewport > viewportWidth - 10) {
          left = (viewportWidth - 10 - containerRect.left) - tooltipRect.width;
        }

        // If no room above, show below
        if (containerRect.top + top < 10) {
          top = iconTop + iconRect.height + 8;
        }

        tooltip.style.left = left + 'px';
        tooltip.style.top = top + 'px';

        // Show tooltip
        requestAnimationFrame(() => {
          tooltip.style.opacity = '1';
          tooltip.style.visibility = 'visible';
        });
      };

      const hideTooltip = () => {
        if (tooltip) {
          tooltip.style.opacity = '0';
          tooltip.style.visibility = 'hidden';
          setTimeout(() => {
            if (tooltip && tooltip.parentNode) {
              tooltip.parentNode.removeChild(tooltip);
            }
            tooltip = null;
          }, 200);
        }
      };

      // Add event listeners
      icon.addEventListener('mouseenter', showTooltip);
      icon.addEventListener('mouseleave', hideTooltip);
      icon.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
      });
    });

    // Clean up tooltips on page interactions
    document.addEventListener('scroll', () => {
      document.querySelectorAll('.tooltip-popup').forEach(t => {
        if (t.parentNode) t.parentNode.removeChild(t);
      });
    });

    document.addEventListener('click', (e) => {
      if (!e.target.closest('.tooltip-icon')) {
        document.querySelectorAll('.tooltip-popup').forEach(t => {
          if (t.parentNode) t.parentNode.removeChild(t);
        });
      }
    });
  }

  setupShippingCalculator() {
    // Initialize the shipping calculator on page load
    this.updateShippingCalculator();
  }

  updateShippingCalculator() {
    const currentDate = new Date();
    const deliveryRangeEl = document.getElementById('delivery-range');
    const orderDateEl = document.getElementById('order-date');
    const shippedDateEl = document.getElementById('shipped-date');
    const doorstepDateEl = document.getElementById('doorstep-date');

    if (!deliveryRangeEl || !orderDateEl || !shippedDateEl || !doorstepDateEl) {
      console.log('Shipping calculator elements not found');
      return;
    }

    // Determine production days and shipping times based on turnaround selection
    const productionDays = 20;
    const minDeliveryDays = 21;
    const maxDeliveryDays = 23;

    // Calculate dates
    const orderDate = new Date(currentDate);
    const shippedDate = this.addBusinessDays(orderDate, productionDays);
    const doorstepDate = this.addBusinessDays(orderDate, maxDeliveryDays);
    const minDoorstepDate = this.addBusinessDays(orderDate, minDeliveryDays);

    // Format dates
    const formatDate = (date) => {
      const options = { month: 'short', day: 'numeric' };
      const suffix = this.getDateSuffix(date.getDate());
      return date.toLocaleDateString('en-US', options).replace(/\d+/, date.getDate() + suffix);
    };

    // Update delivery range with selected production time
    const productionTimeText = 'Standard (20 business days)';

    if (minDeliveryDays === maxDeliveryDays) {
      deliveryRangeEl.textContent = `${productionTimeText} ${formatDate(doorstepDate)}`;
    } else {
      deliveryRangeEl.textContent = `${productionTimeText} ${formatDate(minDoorstepDate)} to ${formatDate(doorstepDate)}`;
    }

    // Update timeline dates
    orderDateEl.textContent = formatDate(orderDate);
    shippedDateEl.textContent = formatDate(shippedDate);
    doorstepDateEl.textContent = formatDate(doorstepDate);
  }

  addBusinessDays(startDate, days) {
    const result = new Date(startDate);
    let addedDays = 0;

    while (addedDays < days) {
      result.setDate(result.getDate() + 1);
      // Skip weekends (Saturday = 6, Sunday = 0)
      if (result.getDay() !== 0 && result.getDay() !== 6) {
        addedDays++;
      }
    }

    return result;
  }

  getDateSuffix(day) {
    if (day >= 11 && day <= 13) {
      return 'th';
    }
    switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  }

  setupDynamicDescription() {
    // Initialize with default size (4oz)
    this.updateDynamicDescription();

    // Setup accordion dropdown functionality (only one open at a time)
    this.setupAccordionBehavior('.dynamic-description'); // Desktop version
    this.setupAccordionBehavior('.dynamic-description-mobile'); // Mobile version

    // Auto-open the first tab (Description) on page load
    this.openDescriptionTab();
  }

  openDescriptionTab() {
    // Open description tab on desktop
    const desktopDescriptionTitle = document.querySelector('.dynamic-description .dropdown-title[data-target="description-content"]');
    const desktopDescriptionContent = document.getElementById('description-content');

    if (desktopDescriptionTitle && desktopDescriptionContent) {
      desktopDescriptionTitle.classList.add('active');
      desktopDescriptionContent.classList.add('active');
    }

    // Open description tab on mobile
    const mobileDescriptionTitle = document.querySelector('.dynamic-description-mobile .dropdown-title[data-target="description-content-mobile"]');
    const mobileDescriptionContent = document.getElementById('description-content-mobile');

    if (mobileDescriptionTitle && mobileDescriptionContent) {
      mobileDescriptionTitle.classList.add('active');
      mobileDescriptionContent.classList.add('active');
    }
  }

  setupAccordionBehavior(containerSelector) {
    console.log('Setting up accordion behavior for:', containerSelector);
    const container = document.querySelector(containerSelector);
    if (!container) {
      console.log('Container not found:', containerSelector);
      return;
    }

    const dropdownTitles = container.querySelectorAll('.dropdown-title');
    console.log('Found dropdown titles:', dropdownTitles.length);

    dropdownTitles.forEach((title, index) => {
      console.log(`Styling dropdown title ${index}:`, title.textContent);
      // Force bold styling directly on the element
      title.style.fontWeight = '700';
      title.style.fontWeight = 'bold';
      title.style.setProperty('font-weight', '700', 'important');
      console.log('Applied styles to:', title.textContent, 'font-weight:', title.style.fontWeight);

      title.addEventListener('click', (e) => {
        const targetId = title.getAttribute('data-target');
        const content = document.getElementById(targetId);

        if (content) {
          const isCurrentlyActive = title.classList.contains('active');

          // Close all dropdowns in this container first
          dropdownTitles.forEach(otherTitle => {
            const otherTargetId = otherTitle.getAttribute('data-target');
            const otherContent = document.getElementById(otherTargetId);

            if (otherContent) {
              otherTitle.classList.remove('active');
              otherContent.classList.remove('active');
            }
          });

          // If this wasn't active, open it
          if (!isCurrentlyActive) {
            title.classList.add('active');
            content.classList.add('active');
          }
        }
      });
    });
  }

  updateDynamicDescription() {
    const descriptionData = this.getDescriptionData();

    // Update desktop version
    const descriptionContent = document.getElementById('description-content');
    const specificationContent = document.getElementById('specification-content');
    const dielinesContent = document.getElementById('dielines-content');
    const howItWorksContent = document.getElementById('how-it-works-content');

    // Update mobile version
    const descriptionContentMobile = document.getElementById('description-content-mobile');
    const specificationContentMobile = document.getElementById('specification-content-mobile');
    const dielinesContentMobile = document.getElementById('dielines-content-mobile');
    const howItWorksContentMobile = document.getElementById('how-it-works-content-mobile');

    if (descriptionData) {
      // Update desktop
      if (descriptionContent) {
        descriptionContent.innerHTML = descriptionData.description;
      }
      if (specificationContent) {
        specificationContent.innerHTML = descriptionData.specification;
      }
      if (dielinesContent) {
        dielinesContent.innerHTML = descriptionData.dielines;
      }
      if (howItWorksContent && !howItWorksContent.hasAttribute('data-static-journey')) {
        howItWorksContent.innerHTML = descriptionData.howItWorks;
      }

      // Update mobile (same content)
      if (descriptionContentMobile) {
        descriptionContentMobile.innerHTML = descriptionData.description;
      }
      if (specificationContentMobile) {
        specificationContentMobile.innerHTML = descriptionData.specification;
      }
      if (dielinesContentMobile) {
        dielinesContentMobile.innerHTML = descriptionData.dielines;
      }
      if (howItWorksContentMobile && !howItWorksContentMobile.hasAttribute('data-static-journey')) {
        howItWorksContentMobile.innerHTML = descriptionData.howItWorks;
      }
    }
  }

  getDescriptionData() {
    // Greaseproof paper description - same for all cut types
    const descriptionData = {
      description: `
        <p>Our <strong>Grease Resistant Printed Sheets - 38gsm - White</strong> are premium quality food-safe paper sheets perfect for wrapping, lining, and packaging greasy foods. Made from high-quality white paper with excellent grease resistance, these sheets are ideal for bakeries, cafés, food trucks, and takeaway businesses.</p>
        <p>Available in <strong>1 Colour or 2 Colours</strong> printing with options for <strong>Less than 50% coverage</strong> or <strong>More than 50% coverage</strong> — perfect for logos, branding, and custom designs.</p>
        <p>Choose from <strong>Full Cut, Half Cut, Third Cut, or Custom Cut</strong> sizes to suit your specific needs.</p>
        <p><strong>Minimum order: 5,000 sheets.</strong></p>
      `,
      specification: `
        <ul>
          <li><span class="spec-label">Material:</span> <span class="spec-value">Grease-resistant paper</span></li>
          <li><span class="spec-label">Weight:</span> <span class="spec-value">38gsm</span></li>
          <li><span class="spec-label">Colour:</span> <span class="spec-value">White</span></li>
          <li><span class="spec-label">Print Options:</span> <span class="spec-value">1 Colour or 2 Colours</span></li>
          <li><span class="spec-label">Coverage Options:</span> <span class="spec-value">Less than 50% or More than 50%</span></li>
          <li><span class="spec-label">Cut Types:</span> <span class="spec-value">Full Cut, Half Cut, Third Cut, Custom Cut</span></li>
          <li><span class="spec-label">MOQ:</span> <span class="spec-value">5,000 sheets</span></li>
          <li><span class="spec-label">Food Safe:</span> <span class="spec-value">Yes - suitable for direct food contact</span></li>
        </ul>
      `,
      dielines: `
        <p>To ensure perfect print placement, download the template below and apply your design:</p>
        <p style="margin-top: 1rem; font-size: 0.9rem; color: #64748b;">Need help with templates or setting up your artwork? Get in touch — we're here to make it easy.</p>
        <p style="margin-top: 1rem; font-size: 0.9rem; color: #64748b;">For custom cut sizes, please contact us to discuss your specific requirements.</p>
      `,
      howItWorks: `
        <div class="process-timeline">
          <div class="process-step">
            <div class="process-number">1</div>
            <div class="process-text">Choose your size and print type</div>
          </div>
          <div class="process-step">
            <div class="process-number">2</div>
            <div class="process-text">Download the dieline and apply your artwork</div>
          </div>
          <div class="process-step">
            <div class="process-number">3</div>
            <div class="process-text">Upload your final design at checkout or email it to us</div>
          </div>
          <div class="process-step">
            <div class="process-number">4</div>
            <div class="process-text">Receive a digital mockup for approval</div>
          </div>
          <div class="process-step">
            <div class="process-number">5</div>
            <div class="process-text">Production begins after approval</div>
          </div>
        </div>
      `
    };

    return descriptionData;
  }

  setupFormSubmission() {
    const customButton = document.getElementById('custom-add-to-cart-btn');
    if (customButton) {
      customButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.addToCart();
      });
    }
  }

  setupFileUpload() {
    const fileInput = document.querySelector('input[type="file"][name="properties[Design File]"]');
    if (!fileInput) {
      console.log('File upload input not found');
      return;
    }

    const uploadArea = document.querySelector('div[id^="uploadArea-"]');
    const imagePreview = document.querySelector('img[id^="imagePreview-"]');
    const filePreviewArea = document.querySelector('div[id^="filePreviewArea-"]');
    const fileInfo = document.querySelector('div[id^="fileInfo-"]');
    const fileName = document.querySelector('div[id^="fileName-"]');
    const fileSize = document.querySelector('div[id^="fileSize-"]');
    const removeButton = document.querySelector('button[id^="removeFile-"]');

    // Click handler for upload area
    if (uploadArea) {
      uploadArea.addEventListener('click', () => {
        fileInput.click();
      });

      // Drag and drop handlers
      uploadArea.addEventListener('dragover', (e) => {
        e.preventDefault();
        uploadArea.style.borderColor = '#3b82f6';
        uploadArea.style.backgroundColor = '#eff6ff';
      });

      uploadArea.addEventListener('dragleave', (e) => {
        e.preventDefault();
        uploadArea.style.borderColor = '#cbd5e1';
        uploadArea.style.backgroundColor = '#f8fafc';
      });

      uploadArea.addEventListener('drop', (e) => {
        e.preventDefault();
        uploadArea.style.borderColor = '#cbd5e1';
        uploadArea.style.backgroundColor = '#f8fafc';

        const files = e.dataTransfer.files;
        if (files.length) {
          fileInput.files = files;
          this.handleFileSelection(files[0]);
        }
      });
    }

    // File selection handler
    fileInput.addEventListener('change', (e) => {
      const file = e.target.files[0];
      this.handleFileSelection(file);
    });

    // Remove file handler
    if (removeButton) {
      removeButton.addEventListener('click', (e) => {
        e.stopPropagation();
        this.clearFileSelection();
      });
    }
  }

  /**
   * Rasterize first page of PDF to PNG for customizer preview.
   * Original PDF stays in file input for checkout/production.
   */
  async rasterizePdfToImage(pdfFile) {
    const pdfjsLib = window.pdfjsLib;
    if (!pdfjsLib) {
      throw new Error('PDF.js not loaded');
    }
    if (pdfjsLib.GlobalWorkerOptions && !pdfjsLib.GlobalWorkerOptions.workerSrc) {
      pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';
    }
    const url = URL.createObjectURL(pdfFile);
    try {
      const loadingTask = pdfjsLib.getDocument({ url });
      const pdf = await loadingTask.promise;
      const page = await pdf.getPage(1);
      const scale = 2;
      const viewport = page.getViewport({ scale });
      const canvas = document.createElement('canvas');
      canvas.width = viewport.width;
      canvas.height = viewport.height;
      const ctx = canvas.getContext('2d');
      await page.render({ canvasContext: ctx, viewport }).promise;
      const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/png'));
      return new File([blob], 'design-preview.png', { type: 'image/png' });
    } finally {
      URL.revokeObjectURL(url);
    }
  }

  setupPersonaliseUpload() {
    const fileInput = document.querySelector('input[type="file"][name="properties[Design File]"]');
    const trigger = document.getElementById('upload-personalise-trigger');
    const removeBtn = document.getElementById('upload-personalise-remove');

    if (!fileInput) return;

    if (trigger) {
      trigger.addEventListener('click', () => fileInput.click());
      trigger.addEventListener('dragover', (e) => { e.preventDefault(); trigger.style.borderColor = '#3b82f6'; trigger.style.backgroundColor = '#eff6ff'; });
      trigger.addEventListener('dragleave', (e) => { e.preventDefault(); trigger.style.borderColor = '#cbd5e1'; trigger.style.backgroundColor = '#f8fafc'; });
      trigger.addEventListener('drop', (e) => {
        e.preventDefault();
        trigger.style.borderColor = '#cbd5e1';
        trigger.style.backgroundColor = '#f8fafc';
        const files = e.dataTransfer.files;
        if (files.length) { fileInput.files = files; this.handleFileSelection(files[0]); }
      });
    }
    if (removeBtn) removeBtn.addEventListener('click', () => this.clearFileSelection());
  }

  syncPersonaliseUploadToFileState() {
    const fileInput = document.querySelector('input[type="file"][name="properties[Design File]"]');
    const trigger = document.getElementById('upload-personalise-trigger');
    const preview = document.getElementById('upload-personalise-preview');
    const personaliseImg = document.getElementById('upload-personalise-image');
    const personaliseName = document.getElementById('upload-personalise-filename');
    const personaliseSize = document.getElementById('upload-personalise-filesize');
    if (!fileInput || !trigger || !preview) return;
    const hasFile = fileInput.files && fileInput.files.length > 0;
    if (hasFile) {
      const file = fileInput.files[0];
      trigger.style.display = 'none';
      preview.style.display = 'block';
      if (personaliseName) personaliseName.textContent = file.name;
      if (personaliseSize) personaliseSize.textContent = `${(file.size / 1024 / 1024).toFixed(2)}MB`;
      if (file.type.startsWith('image/') && personaliseImg) {
        const r = new FileReader();
        r.onload = (e) => { personaliseImg.src = e.target.result; personaliseImg.style.display = 'block'; };
        r.readAsDataURL(file);
      } else if (personaliseImg) personaliseImg.style.display = 'none';
    } else {
      trigger.style.display = 'block';
      preview.style.display = 'none';
      if (personaliseImg) personaliseImg.style.display = 'none';
    }
  }

  handleFileSelection(file) {
    const uploadArea = document.querySelector('div[id^="uploadArea-"]');
    const imagePreview = document.querySelector('img[id^="imagePreview-"]');
    const filePreviewArea = document.querySelector('div[id^="filePreviewArea-"]');
    const fileName = document.querySelector('div[id^="fileName-"]');
    const fileSize = document.querySelector('div[id^="fileSize-"]');

    if (!file) {
      this.clearFileSelection();
      return;
    }

    // Validate file size (max 10MB)
    if (file.size > 10 * 1024 * 1024) {
      alert('File size must be less than 10MB');
      this.clearFileSelection();
      return;
    }

    // Hide upload area and show preview
    if (uploadArea) uploadArea.style.display = 'none';
    if (filePreviewArea) filePreviewArea.style.display = 'block';

    // Update file info
    if (fileName) fileName.textContent = file.name;
    if (fileSize) fileSize.textContent = `${(file.size / 1024 / 1024).toFixed(2)}MB`;

    // Show image preview for image files
    if (file.type.startsWith('image/') && imagePreview) {
      const reader = new FileReader();
      reader.onload = (e) => {
        imagePreview.src = e.target.result;
        imagePreview.style.display = 'block';
      };
      reader.readAsDataURL(file);
    } else {
      // Hide image preview for non-image files
      if (imagePreview) imagePreview.style.display = 'none';
    }

    // Sync Personalise inline upload
    const persTrigger = document.getElementById('upload-personalise-trigger');
    const persPreview = document.getElementById('upload-personalise-preview');
    const persName = document.getElementById('upload-personalise-filename');
    const persSize = document.getElementById('upload-personalise-filesize');
    const persImg = document.getElementById('upload-personalise-image');
    if (persTrigger && persPreview) {
      persTrigger.style.display = 'none';
      persPreview.style.display = 'block';
      if (persName) persName.textContent = file.name;
      if (persSize) persSize.textContent = `${(file.size / 1024 / 1024).toFixed(2)}MB`;
      if (file.type.startsWith('image/') && persImg) {
        const r = new FileReader();
        r.onload = (e) => { persImg.src = e.target.result; persImg.style.display = 'block'; };
        r.readAsDataURL(file);
      } else if (persImg) persImg.style.display = 'none';
    }

    // Notify customizer: images/SVG directly, PDF needs rasterization first
    if (file.type.startsWith('image/') || file.type === 'image/svg+xml') {
      document.dispatchEvent(new CustomEvent('design:fileUploaded', { detail: { file } }));
    } else if (file.type === 'application/pdf') {
      this.rasterizePdfAndLoadInCustomizer(file, imagePreview, persImg);
    }

    console.log('File selected:', file.name, file.type, file.size);
  }

  /**
   * Rasterize PDF and load into customizer + update preview images.
   */
  rasterizePdfAndLoadInCustomizer(pdfFile, imagePreview, persImg) {
    this.rasterizePdfToImage(pdfFile).then((rasterizedFile) => {
      document.dispatchEvent(new CustomEvent('design:fileUploaded', { detail: { file: rasterizedFile } }));
      const dataUrlReader = new FileReader();
      dataUrlReader.onload = (e) => {
        const dataUrl = e.target.result;
        if (imagePreview) { imagePreview.src = dataUrl; imagePreview.style.display = 'block'; }
        if (persImg) { persImg.src = dataUrl; persImg.style.display = 'block'; }
      };
      dataUrlReader.readAsDataURL(rasterizedFile);
    }).catch((err) => {
      console.error('PDF rasterization failed:', err);
      alert('Could not load PDF for preview. The original file will still be saved for production.');
    });
  }

  clearFileSelection() {
    const fileInput = document.querySelector('input[type="file"][name="properties[Design File]"]');
    const uploadArea = document.querySelector('div[id^="uploadArea-"]');
    const imagePreview = document.querySelector('img[id^="imagePreview-"]');
    const filePreviewArea = document.querySelector('div[id^="filePreviewArea-"]');

    // Clear the file input
    if (fileInput) fileInput.value = '';

    // Show upload area and hide preview
    if (uploadArea) uploadArea.style.display = 'block';
    if (filePreviewArea) filePreviewArea.style.display = 'none';
    if (imagePreview) imagePreview.style.display = 'none';

    // Notify customizer to clear canvas
    document.dispatchEvent(new CustomEvent('design:fileCleared'));

    // Sync Personalise inline upload if present
    const pTrigger = document.getElementById('upload-personalise-trigger');
    const pPreview = document.getElementById('upload-personalise-preview');
    const pImg = document.getElementById('upload-personalise-image');
    if (pTrigger && pPreview) {
      pTrigger.style.display = 'block';
      pPreview.style.display = 'none';
      if (pImg) pImg.style.display = 'none';
    }

    console.log('File selection cleared');
  }



  getPricingKey() {
    return `${this.selectedCutType}_${this.selectedColours}_${this.selectedCoverage}`;
  }

  getVariantMapping() {
    return this.variantMapping;
  }

  // Get the variant ID for the currently selected configuration and quantity
  getSelectedVariantId() {
    const pricingKey = this.getPricingKey();
    const quantityKey = String(this.selectedQuantity);
    const mapping = this.getVariantMapping();
    const variantId = mapping[pricingKey]?.[quantityKey];

    if (!variantId) {
      console.error(`[Variant ID Error] No variant found for:`, {
        pricingKey,
        quantity: quantityKey,
        selectedCutType: this.selectedCutType,
        selectedColours: this.selectedColours,
        selectedCoverage: this.selectedCoverage,
        availableKeys: Object.keys(mapping),
        availableQuantities: mapping[pricingKey] ? Object.keys(mapping[pricingKey]) : 'N/A'
      });
    }

    return variantId;
  }

  getUnitsPerCarton() {
    return this.UNITS_PER_CARTON;
  }

  // Helper function to get the appropriate lid quantity based on cup quantity
  getLidQuantityTier(cupQuantity) {
    // Map cup quantities to lid variant quantities
    if (cupQuantity <= 250) return "250";
    if (cupQuantity <= 500) return "500";
    if (cupQuantity <= 1000) return "1000";
    if (cupQuantity <= 2000) return "2000";
    if (cupQuantity <= 3000) return "3000";
    if (cupQuantity <= 4000) return "4000";
    if (cupQuantity <= 5000) return "5000";
    if (cupQuantity >= 10000) return "10000";
    return "5000"; // Default fallback
  }

  async loadProductData() {
    // Load data for all cut sizes
    const cuts = Object.keys(this.productHandles);

    await Promise.all(cuts.map(async (cut) => {
      if (!this.productDataMap[cut]) {
        try {
          const handle = this.productHandles[cut];
          const response = await fetch(`/products/${handle}.js`);
          if (response.ok) {
            this.productDataMap[cut] = await response.json();
            console.log(`Loaded product data for ${cut}`);
          }
        } catch (error) {
          console.error(`Failed to load product data for ${cut}:`, error);
        }
      }
    }));

    // For convenience, set this.productData to the currently selected cut
    this.productData = this.productDataMap[this.selectedCutType];
    return this.productData;
  }

  // Robust fetch of variant price in dollars by ID
  async fetchVariantPriceDollars(variantId) {
    const endpoints = [
      `/variants/${variantId}.json`,
      `/variants/${variantId}.js`
    ];
    for (const url of endpoints) {
      try {
        const res = await fetch(url, { credentials: 'same-origin', headers: { 'Accept': 'application/json,text/plain,*/*' } });
        if (!res.ok) continue;
        let data;
        try { data = await res.clone().json(); }
        catch(_) {
          const txt = await res.text();
          try { data = JSON.parse(txt); }
          catch(_) {
            const m = /"price"\s*:\s*"?([0-9]+(?:\.[0-9]+)?)"?/i.exec(txt);
            if (m) {
              const num = parseFloat(m[1]);
              if (isFinite(num)) return num;
            }
            continue;
          }
        }
        const v = data?.variant || data;
        if (!v) continue;
        let p = v.price;
        p = typeof p === 'string' ? parseFloat(p) : Number(p);
        if (!isFinite(p)) continue;
        if (p > 100 && Number.isInteger(p)) p = p / 100;
        return p;
      } catch(_) {}
    }
    return null;
  }

  async fetchVariantPricesBatch(variantIds) {
    if (!this.variantPriceCache) this.variantPriceCache = new Map();
    const unique = [...new Set((variantIds || []).filter(Boolean))];
    const missing = unique.filter(id => !this.variantPriceCache.has(id));
    await Promise.all(missing.map(async (id) => {
      const p = await this.fetchVariantPriceDollars(id);
      if (p != null) this.variantPriceCache.set(id, p);
    }));
  }

  async updatePricingTable() {
    console.log('[Debug] updatePricingTable called');
    const formEl = document.querySelector('#product-form-greaseproof-paper');
    const tbody = formEl ? formEl.querySelector('#quantity-grid-body') : document.getElementById('quantity-grid-body');
    if (!tbody) {
      console.error('[Debug] quantity-grid-body element not found!');
      return;
    }

    // Prevent duplicate renders from overlapping async calls
    this._pricingRenderCounter = (this._pricingRenderCounter || 0) + 1;
    const renderId = this._pricingRenderCounter;

    const pricingKey = this.getPricingKey();
    const mapping = this.getVariantMapping();
    const variants = mapping[pricingKey];

    console.log('[Debug] Updating pricing for:', pricingKey, variants);
    console.log('[Debug] Current state - CutType:', this.selectedCutType, 'Colours:', this.selectedColours, 'Coverage:', this.selectedCoverage);

    // Debug membership pricing
    console.log('[Debug] MembershipPricing available:', !!window.MembershipPricing);
    if (window.MembershipPricing) {
      console.log('[Debug] Customer tier:', window.MembershipPricing.getCustomerTier());
      console.log('[Debug] Discount percent:', window.MembershipPricing.getDiscountPercent());
    }

    if (!variants) {
      if (renderId !== this._pricingRenderCounter) return;
      console.error('[Debug] No variants found for pricing key:', pricingKey);
      tbody.innerHTML = '<tr><td colspan="5" style="text-align: center; padding: 2em;">No pricing available for this configuration</td></tr>';
      return;
    }

    // Load product data for price lookup (but don't require it)
    console.log('[Debug] Loading product data...');
    await this.loadProductData();
    console.log('[Debug] Product data loaded:', !!this.productData);

    const frag = document.createDocumentFragment();

    // Get available quantities for this configuration and prefetch live prices
    const quantities = Object.keys(variants).map(q => parseInt(q)).sort((a, b) => a - b);
    
    // Ensure cache exists and fetch all variant prices
    if (!this.variantPriceCache) this.variantPriceCache = new Map();
    await this.fetchVariantPricesBatch(Object.values(variants));

    console.log('[Debug] Available quantities:', quantities);

    for (let i = 0; i < quantities.length; i++) {
      const qty = quantities[i];
      const variantId = variants[qty.toString()];

      // Try to find variant in product data
      let variant = null;
      let variantPrice = 0;
      let unitPrice = 0;

      if (this.productData) {
        variant = this.productData.variants.find(v => v.id == variantId);
      }

      console.log(`[Pricing Debug] ${pricingKey} - Qty: ${qty}, VariantID: ${variantId}, Found: ${!!variant}`);

      if (variant) {
        // Use live Shopify pricing
        if (typeof variant.price === 'string') {
          variantPrice = parseFloat(variant.price);
        } else {
          // Assume cents, convert to dollars
          variantPrice = variant.price / 100;
        }
        unitPrice = variantPrice / qty;
      } else {
        // Try cached or live fetch by ID
        const cached = this.variantPriceCache.get(variantId);
        const live = cached != null ? cached : await this.fetchVariantPriceDollars(variantId);
        
        if (live != null) {
          variantPrice = live;
          unitPrice = live / qty;
          if (cached == null) this.variantPriceCache.set(variantId, live);
        } else {
          console.warn(`Variant ${variantId} not found in product data or API for ${pricingKey}.`);
          variantPrice = 0;
          unitPrice = 0;
        }
      }

      const row = document.createElement('tr');
      row.classList.add('quantity-row');
      row.dataset.quantity = qty;

      // Make entire row clickable
      row.addEventListener('click', () => {
        const radio = row.querySelector('input[type="radio"]');
        if (radio) {
          radio.checked = true;
          this.selectedQuantity = qty;
          this.currentUnitPrice = unitPrice;
          this.updateRowSelection();
          this.updateSelectedQuantityDisplay();
          this.updateMediaGalleryForSelectedVariant();
        }
      });

      // Radio button
      const radioCell = document.createElement('td');
      const radio = document.createElement('input');
      radio.type = 'radio';
      radio.name = 'quantity_selection';
      radio.value = qty;
      radio.addEventListener('change', () => {
        if (radio.checked) {
          this.selectedQuantity = qty;
          this.currentUnitPrice = unitPrice;
          this.updateRowSelection();
          this.updateSelectedQuantityDisplay();
          this.updateMediaGalleryForSelectedVariant();
        }
      });

      // Pre-select first option or maintain current selection
      if ((i === 0 && this.selectedQuantity === null) || qty === this.selectedQuantity) {
        radio.checked = true;
        this.selectedQuantity = qty;
        this.currentUnitPrice = unitPrice;
        row.classList.add('selected');
      }

      radioCell.appendChild(radio);
      row.appendChild(radioCell);

      // Quantity
      const qtyCell = document.createElement('td');
      qtyCell.textContent = qty.toLocaleString();
      row.appendChild(qtyCell);

      // Cartons
      const cartonsCell = document.createElement('td');
      const cartons = qty / this.getUnitsPerCarton();
      cartonsCell.textContent = this.decimalToFraction(cartons);
      row.appendChild(cartonsCell);

      // Unit Price (with membership pricing)
      const unitPriceCell = document.createElement('td');

      // Check if customer has membership tags directly from body data attribute
      const customerTags = document.body.dataset.customerTags || '';
      const tags = customerTags.toLowerCase().split(',').map(tag => tag.trim());
      // Use centralized membership pricing system
      let memberTier = null;
      let discountPercent = 0;

      if (window.MembershipPricing) {
        memberTier = window.MembershipPricing.getCustomerTier();
        discountPercent = window.MembershipPricing.getDiscountPercent();
      } else {
        // Fallback to legacy logic for bronze/silver/gold/trade
        if (tags.includes('trade')) {
          memberTier = 'trade';
          discountPercent = 20;
        } else if (tags.includes('gold')) {
          memberTier = 'gold';
          discountPercent = 15;
        } else if (tags.includes('silver')) {
          memberTier = 'silver';
          discountPercent = 10;
        } else if (tags.includes('bronze')) {
          memberTier = 'bronze';
          discountPercent = 5;
        }
      }

      if (memberTier && discountPercent > 0) {
        const discountedUnitPrice = unitPrice * (1 - discountPercent / 100);
        console.log(`[Membership Debug] Unit Price - Original: $${unitPrice.toFixed(2)}, Discounted: $${discountedUnitPrice.toFixed(2)}, Tier: ${memberTier}`);

        unitPriceCell.innerHTML = `
          <span class="original-price">$${unitPrice.toFixed(2)}</span>
          <span class="member-price member-${memberTier}">$${discountedUnitPrice.toFixed(2)}</span>
        `;
      } else {
        unitPriceCell.textContent = `$${unitPrice.toFixed(2)}`;
      }
      row.appendChild(unitPriceCell);

      // Total Price (with membership pricing)
      const totalCell = document.createElement('td');

      if (memberTier && discountPercent > 0) {
        const discountedTotal = variantPrice * (1 - discountPercent / 100);
        console.log(`[Membership Debug] Total Price - Original: $${variantPrice.toFixed(2)}, Discounted: $${discountedTotal.toFixed(2)}, Tier: ${memberTier}`);

        totalCell.innerHTML = `
          <span class="original-price">$${variantPrice.toFixed(2)}</span>
          <span class="member-price member-${memberTier}">$${discountedTotal.toFixed(2)}</span>
        `;
      } else {
        totalCell.textContent = `$${variantPrice.toFixed(2)}`;
      }
      row.appendChild(totalCell);

      frag.appendChild(row);
      console.log(`[Debug] Row created for quantity ${qty}`);
    }
    // Drop stale renders if a newer one started while building
    if (renderId !== this._pricingRenderCounter) return;
    tbody.innerHTML = '';
    tbody.appendChild(frag);

    console.log(`[Debug] Total rows created: ${quantities.length}`);
    console.log(`[Debug] tbody children count: ${tbody.children.length}`);

    this.updateRowSelection();
    this.updateSelectedQuantityDisplay();
    this.updateOrderSummary();
  }

  calculateUnitPrice() {
    // Return the cached unit price from live data
    return this.currentUnitPrice || 0;
  }

  // Helper method to calculate variant total price
  calculateVariantTotalPrice() {
    // Calculate total price from live variant data
    const unitPrice = this.calculateUnitPrice();
    const totalPrice = unitPrice * this.selectedQuantity;

    console.log(`[VariantTotalPrice] Unit: $${unitPrice}, Qty: ${this.selectedQuantity}, Total: $${totalPrice}`);

    return totalPrice;
  }

  // Smart number formatting - only show decimals if needed, max 2 decimals
  formatNumber(number) {
    const rounded = Math.round(number * 100) / 100; // Round to 2 decimal places
    return rounded % 1 === 0 ? rounded.toString() : rounded.toFixed(2);
  }

  updateRowSelection() {
    // Remove selection from all rows
    document.querySelectorAll('.quantity-row').forEach(row => {
      row.classList.remove('selected');
    });

    // Add selection to current row
    if (this.selectedQuantity) {
      const selectedRow = document.querySelector(`[data-quantity="${this.selectedQuantity}"]`);
      if (selectedRow) {
        selectedRow.classList.add('selected');
      }
    }
  }

  updateSelectedQuantityDisplay() {
    // Update any selected quantity display elements
    const selectedQtyElements = document.querySelectorAll('.selected-quantity-display');
    selectedQtyElements.forEach(el => {
      el.textContent = this.selectedQuantity ? this.selectedQuantity.toLocaleString() : '';
    });

    // Update order summary
    this.updateOrderSummary();
  }

  updateOrderSummary() {
    if (!this.selectedQuantity) return;

    // Get current pricing for display calculations
    const pricingKey = this.getPricingKey();
    const mapping = this.getVariantMapping();
    const variants = mapping[pricingKey];
    const variant = variants[this.selectedQuantity.toString()];

    if (!variant) {
      console.warn(`Variant not found for quantity: ${this.selectedQuantity}`);
      return;
    }

    // Get membership info for all calculations
    const customerTags = document.body.dataset.customerTags || '';
    const tags = customerTags.toLowerCase().split(',').map(tag => tag.trim());
    // Use centralized membership pricing system
    let memberTier = null;
    let memberDiscountPercent = 0;

    if (window.MembershipPricing) {
      memberTier = window.MembershipPricing.getCustomerTier();
      memberDiscountPercent = window.MembershipPricing.getDiscountPercent();
    } else {
      // Fallback to legacy logic for bronze/silver/gold/trade
      if (tags.includes('trade')) {
        memberTier = 'trade';
        memberDiscountPercent = 20;
      } else if (tags.includes('gold')) {
        memberTier = 'gold';
        memberDiscountPercent = 15;
      } else if (tags.includes('silver')) {
        memberTier = 'silver';
        memberDiscountPercent = 10;
      } else if (tags.includes('bronze')) {
        memberTier = 'bronze';
        memberDiscountPercent = 5;
      }
    }

    let unitPrice = this.calculateUnitPrice();
    let lidPrice = 0;
    let rushFee = 0;
    // Calculate cup total and apply member discount
    let cupTotal = this.selectedQuantity * unitPrice;

    // Apply member discount to cup total
    if (memberDiscountPercent > 0) {
      cupTotal = cupTotal * (1 - memberDiscountPercent / 100);
      console.log(`[Cup Debug] Member discount applied to cup total: ${memberDiscountPercent}% off`);
    }

    // Calculate plate fees
    const coloursCount = parseInt(this.selectedColours.replace('Colour', '').replace('Colours', '')) || 1;
    let plateFee = 0;
    
    // We'll calculate the plate fee by fetching the variant price or using a default if not cached
    const platePrice = this.variantPriceCache.get(this.PLATE_FEE_VARIANT_ID) || 250.00; // Defaulting to $250 if unknown
    plateFee = coloursCount * platePrice;

    let totalPrice = cupTotal + plateFee;

    // Update plate fee display
    const plateRow = document.getElementById('summary-plate-row');
    const plateEl = document.getElementById('summary-plate-fee');
    if (plateRow) {
      plateRow.style.display = plateFee > 0 ? 'flex' : 'none';
    }
    if (plateEl) {
      plateEl.textContent = `$${plateFee.toFixed(2)}`;
    }

    // No lids for greaseproof paper
    document.getElementById('summary-lid-row').style.display = 'none';



    // Update summary elements (with membership pricing)
    const summaryQuantity = document.getElementById('summary-quantity');
    const summaryUnitPrice = document.getElementById('summary-unit-price');
    const summaryTotal = document.getElementById('summary-total');

    if (summaryQuantity) summaryQuantity.textContent = this.selectedQuantity.toLocaleString();

    if (summaryUnitPrice) {
      if (memberTier && memberDiscountPercent > 0) {
        const discountedUnitPrice = unitPrice * (1 - memberDiscountPercent / 100);
        console.log(`[Membership Debug] Summary Unit Price - Original: $${unitPrice.toFixed(2)}, Discounted: $${discountedUnitPrice.toFixed(2)}, Tier: ${memberTier}`);
        summaryUnitPrice.innerHTML = `
          <span class="original-price">$${unitPrice.toFixed(2)}</span>
          <span class="member-price member-${memberTier}">$${discountedUnitPrice.toFixed(2)}</span>
        `;
      } else {
        summaryUnitPrice.textContent = `$${unitPrice.toFixed(2)}`;
      }
    }

    if (summaryTotal) {
      if (memberTier && memberDiscountPercent > 0) {
        // For members: Calculate original totals to show accurate total savings
        const originalCupTotal = this.selectedQuantity * this.calculateUnitPrice();
        const originalLidPrice = this.requireLids ? this.selectedQuantity * (this.selectedQuantity >= 1000 ? this.LID_PRICE_HIGH_QTY : this.LID_PRICE_LOW_QTY) : 0;
        const originalSubtotal = originalCupTotal + originalLidPrice;

        // Calculate individual savings breakdown for accurate total
        const cupSavings = originalCupTotal * (memberDiscountPercent / 100);
        const lidSavings = originalLidPrice * (memberDiscountPercent / 100);
        const totalSavings = cupSavings + lidSavings;

        console.log(`[Membership Debug] Savings Breakdown:`);
        console.log(`- Cup Savings (${memberDiscountPercent}%): $${cupSavings.toFixed(2)}`);
        console.log(`- Lid Savings (${memberDiscountPercent}%): $${lidSavings.toFixed(2)}`);
        console.log(`- Total Member Savings: $${totalSavings.toFixed(2)}`);
        console.log(`- Original Subtotal: $${originalSubtotal.toFixed(2)}`);
        console.log(`- Final Total: $${totalPrice.toFixed(2)}`);
        console.log(`- Verification: ${originalSubtotal.toFixed(2)} - ${totalSavings.toFixed(2)} = ${(originalSubtotal - totalSavings).toFixed(2)}`);

        // Display final total with original subtotal crossed out
        summaryTotal.innerHTML = `
          <span class="original-price">$${originalSubtotal.toFixed(2)}</span>
          <span class="member-price member-${memberTier}">$${totalPrice.toFixed(2)}</span>
        `;

        // Show and update discount row ONLY for tagged members
        const discountRow = document.getElementById('summary-discount-row');
        const discountLabel = document.getElementById('summary-discount-label');
        const discountAmountEl = document.getElementById('summary-discount-amount');

        if (discountRow && discountLabel && discountAmountEl) {
          console.log(`[Discount Debug] Showing accurate total savings for ${memberTier} member: -$${totalSavings.toFixed(2)}`);
          discountRow.style.display = 'flex'; // Show the discount row
          discountLabel.textContent = `${memberTier.toUpperCase()} Member Discount (${memberDiscountPercent}%):`;
          discountAmountEl.textContent = `-$${totalSavings.toFixed(2)}`;
          discountAmountEl.style.color = '#28a745'; // Green color for savings
          discountAmountEl.style.fontWeight = '600'; // Make it stand out
        }
      } else {
        summaryTotal.textContent = `$${totalPrice.toFixed(2)}`;

        // Hide discount row for non-members
        const discountRow = document.getElementById('summary-discount-row');
        if (discountRow) {
          console.log('[Discount Debug] Hiding discount row - no membership tags found');
          discountRow.style.display = 'none';
        }
      }
    }
  }

  async addToCart() {
    const button = document.getElementById('custom-add-to-cart-btn');
    if (!button) return;

    // Validate that a design file is uploaded
    const fileInput = document.querySelector('input[type="file"][name="properties[Design File]"]');
    // File upload is now optional, so skip this check

    // Show loading state
    button.classList.add('loading');
    button.disabled = true;

    try {
      // Get the correct variant ID based on cut type, colours, coverage, and quantity
      // This MUST match the variant ID shown in the pricing table for the selected quantity
      const variantId = this.getSelectedVariantId();
      
      const customLengthInput = document.getElementById('custom-length-input');
      const customWidthInput = document.getElementById('custom-width-input');
      
      if (this.selectedCutType === 'CustomCut') {
         if (!customLengthInput || !customLengthInput.value || !customWidthInput || !customWidthInput.value) {
           this.showMessage('Please enter both Length and Width for your custom size.', 'error');
           button.classList.remove('loading');
           button.disabled = false;
           return;
         }
      }

      if (!variantId) {
        const pricingKey = this.getPricingKey();
        const quantityKey = String(this.selectedQuantity);
        throw new Error(`No variant found for ${pricingKey} - ${quantityKey} units. Please check variant mapping.`);
      }

      console.log('[AddToCart Debug] Using variant ID from pricing table:', variantId);
      console.log('[AddToCart Debug] Configuration:', {
        cutType: this.selectedCutType,
        colours: this.selectedColours,
        coverage: this.selectedCoverage,
        quantity: this.selectedQuantity
      });

      // Recompute live unit price from ProductJSON for selected variant before sending
      try {
        await this.loadProductData();
        const mapping = this.getVariantMapping();
        const pk = this.getPricingKey();
        const selId = mapping[pk]?.[String(this.selectedQuantity)];
        const v = this.productData?.variants?.find(v => v.id.toString() === String(selId));
        if (v) {
          let p = typeof v.price === 'string' ? parseFloat(v.price) : Number(v.price);
          if (p > 100) p = p / 100;
          if (this.selectedQuantity) this.currentUnitPrice = p / this.selectedQuantity;
        }
      } catch (_) { }

      // Create FormData to handle file upload
      const formData = new FormData();

      // Add the main greaseproof paper variant
      formData.append('items[0][id]', variantId);
      formData.append('items[0][quantity]', '1');

      let itemIndex = 1;
      
      // Add plate fee as second item if we have colours
      const coloursCount = parseInt(this.selectedColours.replace('Colour', '').replace('Colours', '')) || 0;
      if (coloursCount > 0) {
        formData.append(`items[${itemIndex}][id]`, this.PLATE_FEE_VARIANT_ID);
        formData.append(`items[${itemIndex}][quantity]`, coloursCount.toString());
        formData.append(`items[${itemIndex}][properties][For Product]`, 'Greaseproof Paper');
        itemIndex++;
      }
      // Append Custom Dimensions if Custom Cut
      if (this.selectedCutType === 'CustomCut') {
         const len = document.getElementById('custom-length-input').value;
         const wid = document.getElementById('custom-width-input').value;
         formData.append('items[0][properties][Custom Length]', `${len}mm`);
         formData.append('items[0][properties][Custom Width]', `${wid}mm`);
      }

      // Add the uploaded file (original PDF/image - for production)
      if (fileInput.files[0]) {
        formData.append('items[0][properties][Design File]', fileInput.files[0]);
      }

      // Add customized preview (how they laid it out) if customizer has content
      const customizer = window.GreaseproofCustomizer;
      if (customizer) {
        formData.append('items[0][properties][Customizer Config]', customizer.exportConfig());
        const previewBlob = await customizer.exportCanvasAsPngBlob();
        if (previewBlob) {
          const previewFile = new File([previewBlob], 'customized-preview.png', { type: 'image/png' });
          formData.append('items[0][properties][Customized Preview]', previewFile);
        }
      }
      // Rush fee removed

      // Submit to cart using FormData (supports file uploads)
      const response = await fetch('/cart/add', {
        method: 'POST',
        body: formData
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to add to cart: ${response.status} - ${errorText}`);
      }

      // Success
      document.dispatchEvent(new CustomEvent('cart:updated'));
      // Set flag for success state after page refresh
      localStorage.setItem('cartAddSuccess', 'true');
      // Reload page to update cart UI (since we're using form submission)
      setTimeout(() => {
        window.location.reload();
      }, 1000);

    } catch (error) {
      console.error('Cart error:', error);
      this.showMessage(`Error adding to cart: ${error.message}`, 'error');
    } finally {
      button.classList.remove('loading');
      button.disabled = false;
    }
  }

  showMessage(text, type) {
    console.log('showMessage called:', text, type);

    // Remove existing messages
    const existingMessages = document.querySelectorAll('.cup-message');
    existingMessages.forEach(msg => msg.remove());

    // Create new toast message
    const message = document.createElement('div');
    message.className = `cup-message cup-${type}-message cup-toast-message`;
    message.textContent = text;

    // Position the toast near the Add to cart button
    const addToCartButton = document.querySelector('#custom-add-to-cart-btn') ||
      document.querySelector('.custom-add-to-cart-button') ||
      document.querySelector('.product-form-greaseproof-paper__cart-submit') ||
      document.querySelector('#product-form-greaseproof-paper button[type="submit"]') ||
      document.querySelector('button[name="add"]');

    console.log('Found button:', addToCartButton);

    if (addToCartButton) {
      const buttonRect = addToCartButton.getBoundingClientRect();
      console.log('Button rect:', buttonRect);

      // Position the toast near the button
      message.style.position = 'fixed';
      message.style.top = `${buttonRect.top + (buttonRect.height / 2) - 30}px`;
      message.style.right = '20px';
      message.style.zIndex = '9999';

      document.body.appendChild(message);
      console.log('Toast appended to body');

      // Trigger slide-in animation
      setTimeout(() => {
        message.classList.add('show');
        console.log('Toast show class added');
      }, 10);

      // Auto-remove after 3 seconds
      setTimeout(() => {
        message.classList.add('hide');
        setTimeout(() => {
          message.remove();
          console.log('Toast removed');
        }, 300); // Allow fade-out animation to complete
      }, 3000);
    } else {
      console.warn('Add to cart button not found, falling back to simple display');
      // Fallback: just append to body with default positioning
      message.style.position = 'fixed';
      message.style.top = '20px';
      message.style.right = '20px';
      message.style.zIndex = '9999';

      document.body.appendChild(message);

      setTimeout(() => {
        message.classList.add('show');
      }, 10);

      setTimeout(() => {
        message.classList.add('hide');
        setTimeout(() => {
          message.remove();
        }, 300);
      }, 3000);
    }
  }

  // Helper function to convert decimal to fraction
  decimalToFraction(decimal) {
    if (decimal >= 1) {
      return this.formatNumber(decimal);
    }

    // Common fractions for carton sizes
    const fractions = {
      0.25: '1/4',
      0.5: '1/2',
      0.75: '3/4'
    };

    return fractions[decimal] || this.formatNumber(decimal);
  }

  updateMediaGalleryForSelectedVariant() {
    // If Double Wall, try to show dedicated hero image first
    if (this.selectedWall === 'Double') {
      const switched = this.switchToAltMedia(this.doubleWallHeroAlt);
      if (switched) {
        return;
      }
    }

    // Get the correct variant ID based on current selections
    const pricingKey = this.getPricingKey();
    const quantityKey = String(this.selectedQuantity);
    const mapping = this.getVariantMapping();
    const variantId = mapping[pricingKey]?.[quantityKey];

    if (!variantId) {
      console.log('No variant ID found for:', pricingKey, quantityKey);
      return;
    }

    console.log('Updating for variant ID:', variantId);

    // Update variant ID input
    const variantIdInputs = document.querySelectorAll('input[name="id"]');
    variantIdInputs.forEach(input => {
      input.value = variantId;
      console.log('Updated variant input to:', variantId);
    });

    // Update URL
    const currentUrl = new URL(window.location);
    currentUrl.searchParams.set('variant', variantId);
    window.history.replaceState({}, '', currentUrl.toString());
    console.log('Updated URL variant to:', variantId);

    // Find the variant's featured media and switch to it
    this.switchToVariantMedia(variantId);

    // Trigger a change event on the variant input to let Shopify know
    const variantInput = document.querySelector('input[name="id"]');
    if (variantInput) {
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  switchToAltMedia(altText) {
    try {
      const productScript = document.querySelector(`script[id^="ProductJSON-"]`);
      if (!productScript) {
        return false;
      }
      const productData = JSON.parse(productScript.textContent);
      const mediaItem = (productData.media || []).find(m => {
        const alt = (m.alt || '').trim().toLowerCase();
        return alt === (altText || '').trim().toLowerCase();
      });
      if (!mediaItem || !mediaItem.id) {
        return false;
      }

      const mediaGallery = document.querySelector('media-gallery');
      if (!mediaGallery) {
        return false;
      }
      const sectionId = mediaGallery.dataset.sectionId;
      const targetMediaId = `${sectionId}-${mediaItem.id}`;

      const thumbnail = document.querySelector(`[data-target="${targetMediaId}"]`);
      if (thumbnail) {
        const button = thumbnail.querySelector('button');
        if (button) {
          button.click();
          return true;
        }
      }
      if (mediaGallery.setActiveMedia) {
        mediaGallery.setActiveMedia(targetMediaId, false);
        return true;
      }
      // Manual fallback
      this.manualMediaSwitch(targetMediaId);
      return true;
    } catch (e) {
      console.warn('switchToAltMedia failed:', e);
      return false;
    }
  }

  switchToVariantMedia(variantId) {
    try {
      // Get product data
      const productScript = document.querySelector(`script[id^="ProductJSON-"]`);
      if (!productScript) {
        console.log('No product data script found');
        return;
      }

      const productData = JSON.parse(productScript.textContent);
      const variant = productData.variants?.find(v => v.id == variantId);

      if (!variant || !variant.featured_media?.id) {
        console.log('No variant or featured media found for:', variantId);
        return;
      }

      console.log('Switching to media ID:', variant.featured_media.id, 'for variant:', variant.title);

      // Find the media gallery component
      const mediaGallery = document.querySelector('media-gallery');
      if (!mediaGallery) {
        console.log('Media gallery component not found');
        return;
      }

      // Get the section ID from the media gallery
      const sectionId = mediaGallery.dataset.sectionId;
      const targetMediaId = `${sectionId}-${variant.featured_media.id}`;

      console.log('Looking for media with ID:', targetMediaId);

      // Find the thumbnail with the matching data-target
      const thumbnail = document.querySelector(`[data-target="${targetMediaId}"]`);
      if (thumbnail) {
        const button = thumbnail.querySelector('button');
        if (button) {
          console.log('Found thumbnail button, clicking it');
          button.click();
          return;
        }
      }

      // Fallback: directly call setActiveMedia if thumbnail click didn't work
      console.log('Thumbnail not found, using direct media switching');
      if (mediaGallery.setActiveMedia) {
        mediaGallery.setActiveMedia(targetMediaId, false);
      } else {
        // Manual fallback
        this.manualMediaSwitch(targetMediaId);
      }

    } catch (error) {
      console.error('Error switching variant media:', error);
    }
  }

  manualMediaSwitch(targetMediaId) {
    console.log('Manual media switch to:', targetMediaId);

    // Try to find and activate the target media
    const targetMedia = document.getElementById(targetMediaId);
    if (targetMedia) {
      // Hide all media
      const allMedia = document.querySelectorAll('[id*="-"][id*="media"]');
      allMedia.forEach(media => {
        media.style.display = 'none';
        media.classList.remove('active');
      });

      // Show target media
      targetMedia.style.display = 'block';
      targetMedia.classList.add('active');

      // Update thumbnails
      const allThumbnails = document.querySelectorAll('[data-target]');
      allThumbnails.forEach(thumb => thumb.classList.remove('active'));

      const targetThumbnail = document.querySelector(`[data-target="${targetMediaId}"]`);
      if (targetThumbnail) {
        targetThumbnail.classList.add('active');
      }

      console.log('Manual media switch completed');
    } else {
      console.log('Target media not found:', targetMediaId);
    }
  }

  checkCartAddSuccess() {
    const successFlag = localStorage.getItem('cartAddSuccess');
    if (successFlag === 'true') {
      localStorage.removeItem('cartAddSuccess');
      this.showMessage('Added to cart successfully!', 'success');
    }
  }

  preventAutoScroll() {
    // Prevent automatic scrolling behaviors that might interfere with user experience
    // But allow manual scrolling functions like scrollToShippingCalculator
    const blockScrollIntoView = () => {
      const originalScrollIntoView = Element.prototype.scrollIntoView;
      Element.prototype.scrollIntoView = function (options) {
        // Allow manual scrolling (when called by our functions)
        if (options && (options.block === 'manual' || options.behavior === 'smooth')) {
          return originalScrollIntoView.call(this, options);
        }
        // Block automatic scrolling
        console.log('Blocked automatic scrollIntoView');
        return;
      };
    };

    // Apply the scroll blocking
    blockScrollIntoView();

    // Also prevent hash-based scrolling on page load
    if (window.location.hash) {
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 1);
    }

    // Prevent scroll restoration
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    // Block automatic focus scrolling but allow manual focus
    const originalFocus = HTMLElement.prototype.focus;
    HTMLElement.prototype.focus = function (options) {
      const newOptions = { ...options, preventScroll: true };
      return originalFocus.call(this, newOptions);
    };
  }
}

// Initialize the product when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  // Only initialize if we're on a product page with the cup-specific elements
  if (document.querySelector('.size-btn') || document.querySelector('#quantity-grid-body')) {
    new GreaseproofPaperProduct();
  }
});

// Smooth scroll function for ETA button
function scrollToShippingCalculator(event) {
  event.preventDefault();

  const shippingCalculator = document.getElementById('shipping-calculator');
  if (shippingCalculator) {
    shippingCalculator.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
}

// Smooth scroll function for ETA calculator
function scrollToEtaCalculator(event) {
  event.preventDefault();

  const etaCalculatorSection = document.getElementById('eta-calculator-section');
  if (etaCalculatorSection) {
    etaCalculatorSection.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
}

// Legacy function for backwards compatibility
function scrollToDesignUpload(event) {
  event.preventDefault();

  const designUploadSection = document.getElementById('design-upload-section');
  if (designUploadSection) {
    designUploadSection.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
}

// Test function for toast messages
function testToast() {
  const product = new GreaseproofPaperProduct();
  product.showMessage('Test message!', 'success');
}

// Force bold titles (utility function)
function forceBoldTitles() {
  const titles = document.querySelectorAll('h1, h2, h3, h4, h5, h6');
  titles.forEach(title => {
    title.style.fontWeight = 'bold';
  });
}